// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Bc9-","title":"Info_title__LUvNE","selects":"Info_selects__3mhln","requiredAsterisk":"Info_requiredAsterisk__1dk61"};